import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import { useLegacyAutocompleteContext } from '../legacy-autocomplete-context.js';
import { useLegacyAutocompleteOptionsContext } from '../legacy-autocomplete-options/legacy-autocomplete-options-context.js';
import { highlightText } from '../../../helpers/highlight-text/index.js';
import Text from '../../../components/text/text.js';

const LegacyAutocompleteOption = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      bem,
      optionHasSubtitle,
      renderOption,
      option,
      highlightQuery
    } = _a,
    rest = __rest(_a, ["bem", "optionHasSubtitle", "renderOption", "option", "highlightQuery"]);
  const {
    containerId,
    focusableOptions,
    focusedOption
  } = useLegacyAutocompleteContext();
  const {
    onOptionSelect = () => null,
    onOptionFocus = () => null
  } = useLegacyAutocompleteOptionsContext();
  const isSelected = focusableOptions && option === focusableOptions[focusedOption];
  return /*#__PURE__*/React.createElement("li", {
    role: "presentation",
    className: bem.e('list-item', {
      'single-line': !optionHasSubtitle,
      selected: isSelected
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", Object.assign({
    role: "option",
    "aria-selected": isSelected,
    id: "".concat(containerId, "-option-").concat(focusableOptions === null || focusableOptions === void 0 ? void 0 : focusableOptions.indexOf(option)),
    className: bem.e('option', {
      'single-line': !optionHasSubtitle
    }),
    onClick: () => {
      onOptionSelect(option, focusableOptions.indexOf(option));
    },
    onKeyDown: event => {
      if (event.key === 'Enter') {
        onOptionSelect(option, focusableOptions.indexOf(option));
      }
    },
    onFocus: event => {
      event.stopPropagation();
      onOptionFocus(option, focusableOptions.indexOf(option), event);
    },
    tabIndex: 0
  }, rest), renderOption ? renderOption(option) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    extraClasses: bem.e('title')
  }, highlightText(option.title, highlightQuery)), optionHasSubtitle && /*#__PURE__*/React.createElement(Text, {
    extraClasses: bem.e('subtitle')
  }, highlightText(option.subtitle || '', highlightQuery))))), option.widget ? (/*#__PURE__*/React.createElement("div", {
    className: bem.e('widget')
  }, option.widget)) : null);
});
const LegacyAutocompleteOptionPropTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  widget: PropTypes.node,
  key: PropTypes.string
});

export { LegacyAutocompleteOption, LegacyAutocompleteOptionPropTypes };
